<template>
	<div
		class="flex-column justify-center "
	>
		<div
			class="bg-login-content bottom"
		>
			<div
				class=" text-center"
			>
				<div
					class=" size-px-36  font-weight-bold  "
				>{{ program.name }}</div>
				<div class="mt-20 size-px-24 color-primary">{{ message ? message : '이미 가입된 정보이거나 잘못된 요청입니다.'}}</div>
			</div>

			<div class="pa-50-20 text-center">

				<div class="mt-50 justify-space-around ">
					<button
						class="btn-fill btn-round"
						@click="toLogin"
					>로그인 바로가기</button>
					<button
						v-if="false"
						class="btn-outline btn-round btn-ss"
						@click="toId">아이디 찾기</button>
					<button
						v-if="false"
						class="btn-outline btn-round btn-ss"
						@click="toPw">비밀번호 찾기</button>
				</div>
			</div>


		</div>
	</div>
</template>

<script>

export default{
	name: 'JoinFalse'
	,props: ['message']
	,data: function() {
		return {

			program:{
				name: '회원가입'
				, title: false
				, bottom: true
				, top_line: true
			}
		}
	}
	,methods: {
		toLogin: function(){
			this.$bus.$emit('to', { name: 'Login'})
		}
		, toId: function(){
			this.$bus.$emit('to', { name: 'FindId'})
		}
		, toPw: function(){
			this.$bus.$emit('to', { name: 'FindPw'})
		}
	}
	,created() {
		this.$bus.$emit('onLoad', this.program)
	}
}
</script>
